import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { injectTellentIsOneSettingsEnabled } from '@core/tellent-logic';
import { injectIsNativeMobileHr } from '@core/tellent-mobile-contracts';
import { AppKind, BRAND, SeatKind, TellentBrand } from '@core/tellent-types';
import {
  BadgeComponent,
  ConnectedOverlayDirective,
  DotComponent,
  IconComponent,
  OverlayOriginDirective,
} from '@core/user-interface-legacy';
import { WalkthroughStepId } from '@core/walkthrough-types';
import { WalkthroughStepOriginDirective } from '@core/walkthrough-ui';

import { TellentAppLogoComponent } from '../tellent-app-logo/tellent-app-logo.component';
import { TellentAppSwitcherNextController } from './controllers/tellent-app-switcher-next.controller';
import { TellentAppSwitcherDropdownComponent } from './tellent-app-switcher-dropdown/tellent-app-switcher-dropdown.component';

@Component({
  selector: 'tlc-app-switcher-next',
  styleUrl: './tellent-app-switcher-next.component.less',
  templateUrl: './tellent-app-switcher-next.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TellentAppLogoComponent,
    IconComponent,
    ConnectedOverlayDirective,
    OverlayOriginDirective,
    TellentAppSwitcherDropdownComponent,
    BadgeComponent,
    TranslatePipe,
    WalkthroughStepOriginDirective,
    DotComponent,
  ],
  viewProviders: [TellentAppSwitcherNextController],
  host: {
    '[class.disabled]': 'disabled()',
  },
})
export class TellentAppSwitcherNextComponent {
  private readonly isNativeMobile = injectIsNativeMobileHr();

  protected readonly TellentBrand = TellentBrand;
  protected readonly AppKind = AppKind;
  protected readonly brand = inject(BRAND);

  public isOneSettingsEnabled = injectTellentIsOneSettingsEnabled();
  public ctrl = inject(TellentAppSwitcherNextController);
  public dropdown = viewChild<ConnectedOverlayDirective>('dropdown');
  public walkthroughId = input<WalkthroughStepId>();

  public walkthroughBeforeRender = input<() => void>(() => (this.dropdown()!.open = true));
  public walkthroughAfterDispose = input<() => void>(() => (this.dropdown()!.open = false));

  public triggerEl = viewChild('trigger', { read: ElementRef });
  public elRef = inject(ElementRef);

  public disabled = computed(() => {
    const apps = this.ctrl.apps();

    const availableApps = Object.entries(apps).filter(([seatKind, app]) =>
      seatKind === SeatKind.Recruitment ? !!app : !!app && !app.active,
    );

    return this.isNativeMobile || availableApps.length === 0;
  });

  public dropdownOpenChange = output<boolean>();

  public dropdownOpenHandler(event: MouseEvent, dropdown: ConnectedOverlayDirective) {
    event.preventDefault();
    event.stopImmediatePropagation();

    dropdown.open = !dropdown.open;
    this.dropdownOpenChange.emit(true);
  }
}
